module.exports = __webpack_public_path__ + "img/graduation-hat.a2907af4.png";